export enum USER_TYPE {
  END_USER = 'end_user',
  BUSINESS_USER = 'business_user'
}

export enum EVENT_TYPE {
  OPEN_DOOR = 'OPEN DOOR',
  INAUGURATION = 'Inauguration',
  CONTEST = 'Contest',
  PARADE = 'Parade',
  CONCERT = 'Concert',
  COURSE = 'Course',
  EXPOSITION = 'Exposition',
  RAFFLE = 'Raffle'
}
